import client from '@/api/client';

export const CONFIRMATION_START_START = 'confirmation/start/START';
export const CONFIRMATION_START_SUCCESS = 'confirmation/start/SUCCESS';
export const CONFIRMATION_START_FAILURE = 'confirmation/start/FAILURE';

export const CONFIRMATION_VERIFY_START = 'confirmation/verify/START';
export const CONFIRMATION_VERIFY_SUCCESS = 'confirmation/verify/SUCCESS';
export const CONFIRMATION_VERIFY_FAILURE = 'confirmation/verify/FAILURE';

export default {
  namespaced: true,
  state: {
    start: {
      error: null,
      loading: true,
      result: {},
    },
    verify: {
      error: null,
      loading: true,
      result: {},
    },
  },
  actions: {
    start({ commit }, payload) {
      commit(CONFIRMATION_START_START);

      return new Promise((resolve, reject) => {
        client.post('/phone_confirmations', payload)
          .then((response) => {
            commit(CONFIRMATION_START_SUCCESS, response);
            resolve(response);
          })
          .catch((error) => {
            commit(CONFIRMATION_START_FAILURE, error);
            reject(error);
          });
      });
    },
    verify({ commit }, payload) {
      commit(CONFIRMATION_VERIFY_START);

      return new Promise((resolve, reject) => {
        client.put('/phone_confirmations/confirm', payload)
          .then((response) => {
            commit(CONFIRMATION_VERIFY_SUCCESS, response);
            resolve(response);
          })
          .catch((error) => {
            commit(CONFIRMATION_VERIFY_FAILURE, error);
            reject(error);
          });
      });
    },
  },
  mutations: {
    [CONFIRMATION_START_START](state) {
      state.start.error = null;
      state.start.loading = true;
      state.start.result = {};
    },
    [CONFIRMATION_START_SUCCESS](state, response) {
      const result = response.data;

      state.start.error = null;
      state.start.loading = false;
      state.start.result = result;
    },
    [CONFIRMATION_START_FAILURE](state, error) {
      let details = error;

      try {
        details = error.response.data.error;
      } catch (err) { /* */ }

      state.start.error = details;
      state.start.loading = false;
      state.start.result = {};
    },
    [CONFIRMATION_VERIFY_START](state) {
      state.verify.error = null;
      state.verify.loading = true;
      state.verify.result = {};
    },
    [CONFIRMATION_VERIFY_SUCCESS](state, response) {
      const result = response.data;

      state.verify.error = null;
      state.verify.loading = false;
      state.verify.result = result;
    },
    [CONFIRMATION_VERIFY_FAILURE](state, error) {
      let details = error;

      try {
        details = error.response.data.error;
      } catch (err) { /* */ }

      state.verify.error = details;
      state.verify.loading = false;
      state.verify.result = {};
    },
  },
};
